import React, {Component} from "react";
import {Redirect} from 'react-router-dom';
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {AJAX, close_popup, compressImage, show_popup, showPreloader, hidePreloader, addStepLog, setUrlSinglePageApp} from "../functions";
import RatingComponent from "../common/RatingComponent";
import Popup from "../popups/Popup";
import PreviewPhoto from "../common/PreviewPhoto";
import {showProgressBarPopup} from "../popups/ProgressBarPopup";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {Link} from "react-router-dom";
import ReturnInstructionButton from "../common/ReturnInstructionButton";
import {withRouter} from "react-router";

class WelcomePage extends Component {
	constructor(props) {
		super(props);
		this.handleSetPage = this.handleSetPage.bind(this);
		this.handleSetGlobalOperation = this.handleSetGlobalOperation.bind(this);
        this.choiceOperation = this.choiceOperation.bind(this);
        this.openAdditPhotoPopup = this.openAdditPhotoPopup.bind(this);
        this.popupState = this.popupState.bind(this);
        this.orderForm = this.orderForm.bind(this);
        this.handleSetPage({name: 'welcome', params: false});
		this.state = {redirect: false, upd: 0, isShowAdditPhotoPopup: false, order: false};
        window.forceUpdateWelcomePage = ()=>this.setState({upd: ++this.state.upd});

        setUrlSinglePageApp(this.props.history.location.pathname);
	}

	componentWillUnmount() {
        window.forceUpdateWelcomePage = null
    }

    componentDidMount() {
        console.log('testt')
    }

    handleSetPage(options) {
	    if (options.name == 'welcome')
            addStepLog('Welcome Page', false);
		this.props.handleSetPage(options);
	}

    handleSetGlobalOperation(value) {
		this.props.handleSetGlobalOperation(value);
	}

	go_to_booking() {
		// window.location.href = 'https://geckopod.com.au/';
        showPreloader();
        addStepLog('Press Button BOOK VEHICLE on Page Welcome', false, '/online-booking/');
//        window.location.href = bm_home_url+'/online-booking/'
	}

    orderForm() {
        addStepLog('Press Button BOOK A VEHICLE on Page Welcome', false);
        this.handleSetPage({name: 'online-booking', params: {}});
        this.setState({order: true});
    }

	choiceOperation(type) {
        switch (type) {
            case 'start':
                addStepLog('Press Button START HIRE on Page Welcome', false);
                this.handleSetPage({name: 'get_vehicle', params: {}});
                this.handleSetGlobalOperation('unlock');
                break;
            case 'end':
                addStepLog('Press Button END HIRE on Page Welcome', false);
                this.handleSetPage({name: 'get_vehicle', params: {afterSubmitRedirectTo: '/return_vehicle/step/1'}});
                // this.handleSetPage({name: 'get_vehicle', params: {afterSubmitRedirectTo: '/your_data_saving'}});
                this.handleSetGlobalOperation('lock');
                break;
        }
        this.setState({redirect: true});
    }

    popupState(prop, val) {
	    this.setState({[prop]: val})
    }
   openAdditPhotoPopup() {
        this.popupState('isShowAdditPhotoPopup', true)
    }

	render() {
	    if (this.state.redirect)
	        return  <Redirect push to="/get_vehicle" />;

        if (this.state.order)
            return  <Redirect push to="/online-booking/" />;

	    let first_name = this.props.client_data.first_name;
		return (<>
            <RedirectOnlyHome />
			<div className={'value-space'}>
				<div className="row">
					<div className="offset-2 col-8 text-center">
						<h1 className="my-4">
                            <span className={'red'}>Hi{window.gClientData.first_name && ' '+window.gClientData.first_name}! </span>
                            <>{window.gClientData.first_name && (<br/>)}Welcome to the ...</>
						</h1>
                        <div>
                            <img src="/wp-content/uploads/2020/11/logo-welcome.png" />
                        </div>
                        <h1 className="mb-3 float-right">
                            ... App.
                        </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7 text-center" style={{marginLeft:"20%"}}>
                        {
                            window.localStorage.getItem('start_timer') !== '1' ? (
                                <button type="button" className="base-input green mb-3"
                                        onClick={() => this.choiceOperation('start') }
                                >
                                    START HIRE
                                </button>
                            ) : ('')
                        }
                        <button type="button" className="base-input red mb-3"
                                onClick={() => this.choiceOperation('end') }>
                            END HIRE
                        </button>
                        <ReturnInstructionButton note={this.props.return_instr_note} />
                        <button className="base-input white mb-3" /*onClick={this.go_to_booking.bind(this)}*/ onClick={this.orderForm}>
                            Book a Vehicle
                        </button>
					</div>
				</div>
                <div className="row">
                    <div className="offset-2 col-8">
                        <RatingComponent reviews={this.props.reviews}/>
                    </div>
                </div>
                <div className="row round_buttons_box">
                    <div className="offset-1 col-10">
                        <div className="d-flex justify-content-between align-items-start">
                            <div className="wrap-camera-button d-flex flex-column align-items-center justify-content-center">
                            {
                                window.localStorage.getItem('start_timer') === '1' && !!window.localStorage.getItem('active_session_key') ? (<>
                                    <div className="round-button bg-red" onClick={this.openAdditPhotoPopup}>
                                        <div className="camera-icon" />
                                    </div>
                                    <span className="red small-text">Upload additional photos</span>
                                </>) : ('')
                            }
                            </div>
                            <a onClick={(event => {event.preventDefault(); showPreloader(); window.location.href = window.bm_url+ '/our-fleet/'})}>
                                <div className="our-fleet-btn" />
                            </a>
                        </div>
                    </div>
                </div>
                <AdditionalPhotoPopup  isShowPopup={this.state.isShowAdditPhotoPopup} onOpen={this.openAdditPhotoPopup} onClose={()=>{this.popupState('isShowAdditPhotoPopup', false)}}/>
			</div>
		</>);
	}
}

class AdditionalPhotoPopup extends Component {
    defaultState = {description: '', photo: '', uploadPercent: 0, id: 0};
    constructor(props) {
        super(props);
        this.state = Object.assign({ showRestartConfirm: false}, this.defaultState);
        this.uploadPhoto = this.uploadPhoto.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
        this.sendPhoto = this.sendPhoto.bind(this);
        this.onCloseRestartConfirm = this.onCloseRestartConfirm.bind(this);
    }

    componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
    }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }

    escFunction(event){
        if(event.keyCode === 27) {
            this.onCloseRestartConfirm()
            this.props.onClose();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.isShowPopup && prevProps.isShowPopup !== this.props.isShowPopup) {
            this.setState(this.defaultState)
        }
    }

    uploadPhoto(e) {
        let t = this;
        let file = e.target.files[0];
        compressImage(
            file,
            (modifiedFile) => {
                let params = {
                    session_key: window.localStorage.getItem('active_session_key'),
                    files: {
                        photo: modifiedFile
                    },
                    action: 'api/booking/upload_additional_photo'
                };

                AJAX(bm_ajax_url, 'POST', params, {
                    response_json: true,
                    func_waiting: ()=>showProgressBarPopup(t.state.uploadPercent),
                    func_callback: function (resp) {
                        close_popup();
                        if (resp.success === 1 && Object.keys(resp.data).length) {
                            console.log(resp.data);
                            t.setState({uploadPercent: 0, photo: resp.data.file_path, id: resp.data.id});
                        } else {
                            if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                                showPopupWithGoBack(resp.errors.main);
                            }
                        }
                    },
                    func_error: function (resp) {
                        close_popup();
                        showPopupWithGoBack(resp.message);
                    },
                    func_progress: function (evt) {
                        if (evt.lengthComputable) {
                            let percentComplete = Math.round(evt.loaded / evt.total * 100);
                            t.setState({uploadPercent: percentComplete}, () => showProgressBarPopup(t.state.uploadPercent));
                        }
                    }
                });
            }
        );
    }

    sendPhoto(e) {
        let t = this;
        if (!t.state.photo) {
            showPopupWithGoBack('You cannot send an additional photo without preloading')
            return;
        }
        let params = {
            action: 'api/booking/send_additional_photo',
            session_key: window.localStorage.getItem('active_session_key'),
            id: t.state.id,
            description: t.state.description.trim()
        };

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1) {
                    t.props.onClose();
                    t.setState({showRestartConfirm: true})
                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            },
        });
    }

    handleChange(event) {
        this.setState({description: event.target.value});
    }

    onCloseRestartConfirm() {
        this.setState({showRestartConfirm: false})
    }

    render() {
        return (
            <>
                <Popup open={this.props.isShowPopup}
                       modal
                       lockScroll
                       closeOnDocumentClick={false}
                       className={"bm-modal"}
                >
                    <>
                        <button type="button" className="close" aria-label="Close" onClick={this.props.onClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div className="clearfix" />
                        <div className="col-12 mb-3">
                            <div className="form-group">
                                {
                                    !this.state.photo.length ? (
                                        <>
                                            <input type="file" id="addit_photo" accept="image/*" capture="camera"
                                                   className="form-control"
                                                   onChange={this.uploadPhoto}
                                            />
                                            <label htmlFor="addit_photo"
                                                   className="base-input mb-4">ADD PHOTO</label>
                                        </>
                                    ) : (
                                        <div className={"photo-preview current_step"}>
                                            <PreviewPhoto src={this.state.photo}/>
                                            <div>Your Photo</div>
                                        </div>
                                    )
                                }
                                <div>
                                    <h2>Description</h2>
                                    <textarea className="form-control" value={this.state.description} onChange={this.handleChange}/>
                                </div>
                                <button type="button" className={"base-input green mt-4"} onClick={this.sendPhoto}>
                                    SEND
                                </button>
                            </div>
                        </div>
                    </>
                </Popup>
                <Popup open={this.state.showRestartConfirm}
                       modal
                       lockScroll
                       closeOnDocumentClick={false}
                       className={"bm-modal"}
                >
                    <>
                        <button type="button" className="close" aria-label="Close" onClick={this.onCloseRestartConfirm}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div className="clearfix" />
                        <div className="col-12 px-3 text-center">
                            <div>Your photo has been sent successfully.</div>
                            <div>Would you like to send more?</div>
                            <div className="row mt-3">
                                <div className="col-6">
                                    <button type="button" className="go-btn go-back" onClick={this.onCloseRestartConfirm} />
                                </div>
                                <div className="col-6">
                                    <button type="button" className="go-btn go-next" onClick={()=>{this.onCloseRestartConfirm(); this.props.onOpen()}}/>
                                </div>

                            </div>
                        </div>
                    </>
                </Popup>
            </>
        )
    }
}

const WelcomePageR = withRouter(WelcomePage);
export default WelcomePageR;
